import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import React from "react";

const DynamicTabs = (props) => {
  const { dynamicTabs = {} } = props;

  let tabsArray = dynamicTabs?.tabs || [];

  if (!Array.isArray(tabsArray)) {
    tabsArray = [tabsArray];
  }

  return (
    <div className="fr-tabs">
      <ul className="fr-tabs__list" role="tablist" aria-label="">
        {tabsArray.map((tab) => (
          <li role="presentation" key={`listItem-${tab.id}`}>
            <button
              type="button"
              id={tab.id}
              className="fr-tabs__tab"
              tabIndex="0"
              role="tab"
              aria-selected="true"
              aria-controls={`${tab.id}-panel`}
            >
              {tab.title}
            </button>
          </li>
        ))}
      </ul>
      {tabsArray.map((tab) => {
        return (
          <Box
            id={`${tab.id}-panel`}
            className="fr-tabs__panel fr-tabs__panel--selected"
            role="tabpanel"
            aria-labelledby={tab.id}
            tabIndex="0"
            sx={{ "& > div": { p: 0 } }}
            key={`tabpanel-${tab.id}`}
          >
            {tab.children}
          </Box>
        );
      })}
    </div>
  );
};

DynamicTabs.propTypes = {
  dynamicTabs: PropTypes.shape(),
};

export default DynamicTabs;
